import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Chat, Message, Participant} from "../../state/chats/chat.model";
import {User} from "../../auth/primitives/user";
import {Store} from "@ngrx/store";
import {ActivatedRoute, Router} from "@angular/router";
import {FilesService} from "../../services/files/files.service";
import {ChatsService} from "../../services/chats.service";
import * as ChatSelectors from "../../state/chats/chat.selector";
import * as AuthSelectors from "../../state/auth/auth.selector";
import {ChatActions} from "../../state/chats/chatActions";
import * as UserSelectors from "../../state/users/users.selector";
import {PaneBackButtonComponent} from "../pane-back-button/pane-back-button.component";
import {FormsModule} from "@angular/forms";
import {ProfileImageComponent} from "../profile-image/profile-image.component";
import {Base64ImageComponent} from "../base64-image/base64-image.component";
import {NgForOf, NgIf} from "@angular/common";
import {ChatMessageComponent} from "../chat-message/chat-message.component";
import {IconsService} from "../../services/icons.service";
import {Base} from "../base-component/base-component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";

@Component({
  selector: 'chat-new',
  standalone: true,
  imports: [
    PaneBackButtonComponent,
    FormsModule,
    Base64ImageComponent,
    NgIf,
    FaIconComponent
  ],
  templateUrl: './chat-new.component.html',
  styleUrl: './chat-new.component.scss'
})
export class ChatNewComponent extends Base implements OnInit {

  user: User
  otherGuy: User
  newMessageText: string = ""
  chatImageBase64: string

  private readonly BOTTOM_THRESHOLD = 40; // px

  constructor(
      private store: Store,
      private route: ActivatedRoute,
      private fileService: FilesService,
      private chatService: ChatsService,
      protected iconsService: IconsService,
      private router: Router
  ) {
    super()
  }

  ngOnInit(): void {
    let querySub = this.route.queryParams.subscribe(params => {
      const userId = params['newChatUserId'];
      this.subs.add(this.store.select(AuthSelectors.selectUser).subscribe(async (user) => {
        this.user = user
      }))
      this.subs.add(this.store.select(UserSelectors.selectUserById(userId)).subscribe(async (otherUser) => {
        this.otherGuy = otherUser
        if (!otherUser) return
        const serverFile = await this.fileService.getFile(otherUser.profile_image_file_id)
        this.chatImageBase64 = serverFile.fileData
      }))
    });
    this.subs.add(querySub)
  }

  autoResize(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';  // Reset first
    textarea.style.height = `${Math.min(textarea.scrollHeight, 150)}px`;
  }

  async sendMessage() {
    if (!this.newMessageText) {
      return
    }
    const newChat = await this.chatService.newChat(
       this.user.display_name + " and " + this.otherGuy.display_name,
       this.user.id,
       [this.user.id, this.otherGuy.id]
    )
    await this.chatService.newMessage(
        newChat.id,
        this.newMessageText,
        this.user.id,
        [], {}
    )
    this.router.navigate(
        [{outlets: {'left-pane': "chat"}}],
        {
          queryParams: {
            chatId: newChat.id,
          },
          queryParamsHandling: 'merge' // optional but common
        })
    this.newMessageText = ""
  }

}
